import React, { useEffect, useRef, useState } from "react";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import Button from "../../component-lib/Molecules/button/Button";
import Table from "../../component-lib/Organisms/table/EventEHRTable";
import { plusIcon, searchIcon } from "../../assets";
import MenuDropdown from "../../component-lib/Molecules/menuDropdown/MenuDropdown";
import useDeviceType from "../../custom-hooks/DeviceType";
import { useNavigate } from "react-router-dom";
import { TEXT_CONSTANTS } from "../../utils/text-constants/textConstants";
import SelectDropdown from "../../component-lib/Atoms/Select/Select";
import EventEHRSwitchButton from "../../component-lib/Molecules/switch-button/EventEHRSwitchButton";
import AddNewFacilityDialog from "./dialogs/AddNewFacilityDialog";
import { useDispatch, useSelector } from "react-redux";
import {
  getFacilityList,
  patchFacilityData,
  postFacilityData,
  deleteFacility,
} from "./FacilityManagementSaga";
import {
  componentKey,
  setCloseAddFacilityDialog,
  setDeleteFacilityResponse,
} from "./FacilityManagementSlice";
import SearchSelectDropdown from "../../component-lib/Atoms/SearchSelectDropdown/EventEHRSearchSelectDropdown";
import { formatPhoneNumber } from "../../utils/phoneNumberFormatter";
import { mapAddressToLocation } from "./constants";
import TooltipForTable from "../../component-lib/Molecules/tooltip/TooltipForTable";
import DeleteFacilityConfirmationDialog from "../dashboard-screen/dialogs/DeleteFacilityConfirmationDialog";

const FacilityManagementScreen = () => {
  const { facilityList, closeAddFacilityDialog, deleteFacilityResponse } =
    useSelector((state: any) => state[componentKey]);
  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rowPerPage, setRowPerPage] = useState("10");
  const [pageNumber, setPageNumber] = useState(1);
  const [openAddFacilityDialog, setOpenAddFacilityDialog] = useState(false);
  const [searchedValue, setSearchValue] = useState<string>("");
  const [status, setStatus] = useState("");
  const [defaultFacilityDataRow, setDefaultFacilityDataRow] = useState<any>({});

  // Delete facility states
  const [openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog] =
    useState(false);
  const [deleteFacilityData, setDeleteFacilityData] = useState<any>(null);
  const [deleteResponseData, setDeleteResponseData] = useState<any>(null);

  const deviceType = useDeviceType();

  // HANDLE DELETE FACILITY
  const handleDeleteFacility = (row: any) => {
    setDeleteFacilityData(row);
    setDeleteResponseData(null);
    // Clear previous response
    dispatch(setDeleteFacilityResponse(null));

    // First call with force=false
    dispatch(
      deleteFacility({
        facilityId: row?.id,
        force: false,
      })
    );
  };

  const FacilityManagementColumns = [
    {
      field: "Facility",
      label: <div>Facility</div>,
      renderLogic: (row: any) => {
        return (
          <p
            className="font-medium text-primary-main cursor-pointer common-text-ellipse-style"
            onClick={() => {
              navigate(`/facility-management/${row?.id}`);
            }}
          >
            {row?.facility}
          </p>
        );
      },
    },
    {
      field: "facilityAdmin",
      label: <div>Facility Admin</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal common-text-ellipse-style">
            {row?.facilityAdmin}
          </p>
        );
      },
    },
    {
      field: "numberOfDepartment",
      label: <div>No. of Departments</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal common-text-ellipse-style ">
            {row?.noOfDepartment}
          </p>
        );
      },
    },
    {
      field: "numberOfPatient",
      label: <div>No. of Patients</div>,
      renderLogic: (row: any) => {
        return (
          <p
            className="font-medium text-primary-main cursor-pointer common-text-ellipse-style "
            onClick={() => {
              navigate(
                `/facility-management/${row?.id}?selectedPatient=patient`
              );
            }}
          >
            {" "}
            {row?.noOfPatient}
          </p>
        );
      },
    },
    // {
    //   field: "location",
    //   label: <div>Summit Address</div>,
    //   renderLogic: (row: any) => {
    //     return <TooltipForTable label={row?.location || "-"} />;
    //   },
    // },
    {
      field: "contactNumber",
      label: <div>Contact Number</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">
            {row?.contactNumber ? formatPhoneNumber(row?.contactNumber) : "-"}
          </p>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any, index: any) => {
        const status =
          row?.status === "Active"
            ? true
            : row?.status === "InActive"
              ? false
              : false;
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <EventEHRSwitchButton
              checked={status}
              onChange={() => {
                const apiPayload = {
                  payload: {
                    status: status ? "InActive" : "Active",
                  },
                  facilityId: row?.id,
                };
                dispatch(patchFacilityData(apiPayload));
              }}
            />
          </div>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "View Facility Details",
                    onClickCb: () => {
                      navigate(`/facility-management/${row?.id}`);
                    },
                  },
                  {
                    label: "Edit Facility",
                    onClickCb: () => {
                      setDefaultFacilityDataRow(row);
                      setOpenAddFacilityDialog(true);
                    },
                  },
                  {
                    label: "Delete Facility",
                    onClickCb: () => {
                      handleDeleteFacility(row);
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // FACILITY MANAGEMENT LIST ROW DATA
  const facilityManagementData = facilityList?.facilitys?.map((data: any) => ({
    facility: data?.name || "-",
    facilityAdmin: data?.contactPerson || "-",
    noOfDepartment: data?.numberOfDepartments || "0",
    noOfPatient: data?._count?.patient || "0",
    // location: data?.address?.addressLine1
    //   ? mapAddressToLocation(data?.address)
    //   : "-",
    contactNumber: data?.contactNumber || "-",
    status: data?.status || false,
    id: data?.id,
    data: data,
  }));

  console.log("facilityManagementData:::::", facilityManagementData);

  useEffect(() => {
    getFacility();
  }, [searchedValue, rowPerPage, pageNumber, status]);

  useEffect(() => {
    if (closeAddFacilityDialog) {
      dispatch(setCloseAddFacilityDialog(false));
      setOpenAddFacilityDialog(false);
      getFacility();
    }
  }, [closeAddFacilityDialog]);

  // Watch for delete facility response
  useEffect(() => {
    if (deleteFacilityResponse && deleteFacilityData) {
      const responseData = deleteFacilityResponse.data;
      const wasForceDelete = deleteFacilityResponse.force === true;

      if (wasForceDelete) {
        // Force delete was called - check if it succeeded
        if (deleteFacilityResponse.success === true || responseData?.success === true) {
          // Force delete succeeded, close dialog and refresh
          setOpenDeleteConfirmationDialog(false);
          setDeleteFacilityData(null);
          setDeleteResponseData(null);
          dispatch(setDeleteFacilityResponse(null));
          // Refresh facility list
          getFacility();
        }
      } else if (!wasForceDelete) {
        // First call (force=false) - always show confirmation dialog
        // Whether success is true or false, we show confirmation
        setDeleteResponseData(responseData);
        setOpenDeleteConfirmationDialog(true);
      }
    }
  }, [deleteFacilityResponse, deleteFacilityData]);

  // HANDLE DELETE CONFIRMATION
  const handleDeleteConfirmation = (action: "cancel" | "delete") => {
    if (action === "cancel") {
      setOpenDeleteConfirmationDialog(false);
      setDeleteFacilityData(null);
      setDeleteResponseData(null);
      dispatch(setDeleteFacilityResponse(null));
      return;
    }

    // User confirmed deletion
    if (deleteFacilityData) {
      // Clear previous response before new call
      dispatch(setDeleteFacilityResponse(null));
      
      dispatch(
        deleteFacility({
          facilityId: deleteFacilityData?.id,
          force: true,
        })
      );
    }
  };

  const getFacility = () => {
    const payload = {
      pageNumber: pageNumber,
      limit: rowPerPage,
      name: searchedValue?.trim(),
      status: status ? status : "",
    };
    dispatch(getFacilityList(payload));
  };

  // HANDLE SEARCH CHANGE VALUE AND ADDED SOME DELAY
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageNumber(1);

    const value = e.target.value;

    // CLEAR THE PREVIOUS TIMEOUT
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // SET A NEW TIMEOUT TO DELAY THE CALLBACK
    typingTimeoutRef.current = setTimeout(() => {
      setSearchValue(value?.trim());
    }, 500); // ADJUST DELAY AS NEEDED
  };

  const handleNewFacilityData = (values: any) => {
    try {
      const payload = {
        name: values?.facilityName,
        contactPerson: values?.contactPerson,
        contactNumber: values?.contactNumber,
        cmoName: values?.cmoName,
        cmoNumber: values?.cmoContactNumber,
        cnoName: values?.cnoName,
        cnoNumber: values?.cnoContactNumber,
        caoName: values?.caoName,
        caoNumber: values?.caoContactNumber,
        email: values?.Email,
        website: values?.website,
        // status: "Active",
        faxId: values?.faxId,
        faxNumber: values?.faxNumber,
        specialities: values?.specialityType,
        poc: values?.placeOfServices,
        isBaseCamp: values?.isBasecamp,
        address: {
          addressLine1: values?.address_1,
          addressLine2: values?.address_2 || "",
          city: values?.city,
          state: values?.state,
          country: values?.country || "",
          pinCode: values?.zipCode,
        },
      };
      if (defaultFacilityDataRow?.facilityAdmin) {
        const facilityUpdatePayload = {
          payload: {
            ...payload,
          },
          facilityId: defaultFacilityDataRow?.data?.id,
        };
        dispatch(patchFacilityData(facilityUpdatePayload));
      } else {
        dispatch(postFacilityData(payload));
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <WrapperCard
      customClasses="m-3 p-3 flex-1 min-h-0"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col h-full gap-3">
        <div
          className={`flex ${deviceType === "mobile" ? "flex-col items-start gap-3" : "items-center"} justify-between w-full`}
        >
          <Heading
            title={TEXT_CONSTANTS?.PATIENT_LIST}
            customStyle={{ color: "#1D1D1D" }}
          />

          <div
            className={`flex ${deviceType === "mobile" ? "w-full justify-between" : ""} gap-3`}
          >
            <div style={{ maxWidth: "350px" }}>
              <SelectDropdown
                label=""
                name="status"
                placeholderValue="All Status"
                displayEmpty={true}
                value={status}
                options={[
                  { label: "Active", value: "Active" },
                  { label: "In Active", value: "InActive" },
                ]}
                onChangeCb={(e) => {
                  setPageNumber(1);
                  setStatus(e.target.value);
                }}
              />
            </div>
            <div>
              <SearchSelectDropdown
                freeSolo={true}
                searchedValue={searchedValue}
                onSearchValueChangeCb={(e) => handleChange(e)}
                size="small"
                label="Search By Facility Admin Name"
                fullWidth={deviceType === "mobile" ? "160px" : "300px"}
                startIcon={
                  <img
                    alt="search-icon"
                    src={searchIcon}
                    width={"18px"}
                    height={"18px"}
                  />
                }
              />
            </div>

            <Button
              startIcon={
                <img
                  src={plusIcon}
                  alt={"search"}
                  className="cursor-pointer w-[19px] h-[19px]"
                />
              }
              label="Add Facility"
              variant="contained"
              onClickCb={() => {
                setDefaultFacilityDataRow({});
                setOpenAddFacilityDialog(true);
              }}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
              }}
            ></Button>
          </div>
        </div>
        <div style={{ overflow: "auto" }}>
          <Table
            columns={FacilityManagementColumns}
            rows={facilityManagementData}
            paginationProps={{
              isPagination: true,
              page: pageNumber,
              totalPages: facilityList?.totalPages,
              totalCount: facilityList?.totalRecords,
              limit: rowPerPage,
              rowsPerPageOptions: [10, 25, 50],
              onPageChange: (page: any) => {
                setPageNumber(page);
              },
              handleChangeRowsPerPage: (rowPerPage: any) => {
                setRowPerPage(rowPerPage);
                setPageNumber(1);
              },
            }}
          />
        </div>
      </div>
      {/* ADD FACILITY DIALOG */}
      {openAddFacilityDialog && (
        <AddNewFacilityDialog
          defaultFacilityData={defaultFacilityDataRow}
          dialogHeading={
            defaultFacilityDataRow?.facilityAdmin
              ? "Edit Facility"
              : "Add New Facility"
          }
          isOpen={openAddFacilityDialog}
          handleClose={() => {
            setOpenAddFacilityDialog(false);
          }}
          handleAddFacilityData={(formData) => {
            handleNewFacilityData(formData);
          }}
        />
      )}

      {openDeleteConfirmationDialog && (
        <DeleteFacilityConfirmationDialog
          isOpen={openDeleteConfirmationDialog}
          dialogHeading="Delete Facility"
          handleClose={handleDeleteConfirmation}
          facilityName={
            deleteFacilityData?.facility || deleteResponseData?.facility?.name
          }
          relatedData={deleteResponseData?.relatedData}
          warning={deleteResponseData?.warning}
          message={deleteResponseData?.message}
        />
      )}
    </WrapperCard>
  );
};

export default FacilityManagementScreen;
